import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomSpinnerModule } from '../custom-spinner/custom-spinner.module';
import { CustomButtonComponent } from './custom-button.component';

@NgModule({
  declarations: [CustomButtonComponent],
  imports: [CommonModule, CustomSpinnerModule],
  exports: [CustomButtonComponent]
})
export class CustomButtonModule {}
